import './findmemberorganisationmap.js';
import './findmemberorganisationsearch.js';
import './findmemberorganisationresult.js';
import './findmemberorganisationbranch.js';

class FindMemberOrganisation {
    constructor() {
        this.listView = document.querySelector("#list-view");
        this.resultContainer = document.querySelector("#list-view .fmo-result");
        this.loadMore = document.querySelector("#list-view .fmo__load-more");
        this.counter = document.querySelector(".fmo-filter__count");
        document.addEventListener("fmo.resultLoaded", evt => {
            this.counter.innerHTML = evt.detail.result.length;
            this.initPagination();
        });
        if (this.loadMore) {
            this.loadMore.addEventListener("click", evt => {
                evt.preventDefault();
                this.listView.classList.remove("overflooded");
            });
        }
    }
    initPagination() {
        this.listView.classList.remove("overflooded");
        if (this.resultContainer.offsetHeight > 3200) {
            this.listView.classList.add("overflooded");
            this.loadMore.innerHTML = "Visa alla " + this.counter.innerHTML + " träffar";
        }
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new FindMemberOrganisation();
});